/**
 * @author Vahagn.Lazyan
 * @since 3/7/2017
 * @version
 */
export var CellStyleTemplate;
(function (CellStyleTemplate) {
    CellStyleTemplate["CARD"] = "sis-form-toolbar__title";
    CellStyleTemplate["TRANSPARENT"] = "sis-form__label";
})(CellStyleTemplate || (CellStyleTemplate = {}));
//# sourceMappingURL=cell.style.template.enum.js.map